import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/app/[locale]/error.tsx");
